<template>
	<div class="game px-12 py-10" v-if="game && game.type">
		<div class="game-header text-left mb-8" v-if="showHeader">
			<p class="game-instruction text-lg" v-if="game.instruction">
				{{game.instruction}}
			</p>
			<p class="game-extra-instruction text-sm" v-if="game.extra_instruction && !showCorrection">
				{{game.extra_instruction}}
			</p>
			<p class="game-result text" v-if="showCorrection">
				Résultats
			</p>
		</div>

		<div class="game-content">
			<component
			ref="game"
			:is="gameComponent"
			:game="game"
			:show-correction="showCorrection"
			@ended="validGame" />
		</div>
		
		<button
		class="faa-button-blue mt-8"
		type="button"
		v-if="!showCorrection && showValidate"
		@click.prevent="validGame">
			Valider
		</button>

		<button
		class="faa-button-blue mt-8"
		type="button"
		v-else-if="showCorrection"
		@click.prevent="skipGame">
			Continuer
		</button>
	</div>
</template>

<script>
	import soundEffectMixin from '@/mixins/soundEffectMixin'

	import TrueFalse from '@/components/scenario/modal/game/TrueFalse'
	import DragDrop from '@/components/scenario/modal/game/DragDrop'
	import QuizSimple from '@/components/scenario/modal/game/QuizSimple'
	import QuizTable from '@/components/scenario/modal/game/QuizTable'

	export default {
		name: 'Game',
		mixins: [soundEffectMixin],
		props: {
			game: {
				type: Object,
				required: false,
				default: null
			}
		},
		data(){
			return {
				showCorrection: false,
				soundEffects: {
					valid: require('../../../assets/sounds/game_validate.mp3'),
					skip: require('../../../assets/sounds/game_continue.mp3'),
				},
			}
		},
		computed: {
			showHeader() {
				return (this.game.type.slug != 'quiz_simple')
			},
			showValidate() {
				return (this.game.type.slug != 'quiz_simple')
			},
			gameComponent() {
				if (!this.game || !this.game.type)
					return null

				switch (this.game.type.slug) {
					case 'true_false':
						return TrueFalse

					case 'drag_drop':
						return DragDrop
					
					case 'quiz_simple':
						return QuizSimple

					case 'quiz_table':
						return QuizTable
					
				}

				return null
			}
		},
		watch: {
			game: {
				handler() {
					// Reset states
					this.showCorrection = false
				},
				immediate: true,
			},
		},
		methods: {
			validGame() {
				this.playSoundEffect('valid')
				this.showCorrection = true
			},
			skipGame() {
				this.playSoundEffect('skip')

				// Get game results
				if (this.$refs.game && this.$refs.game.getResults) {
					const results = this.$refs.game.getResults()

					this.$emit('ended', results)
				}

				this.showCorrection = false
				this.$emit('next')
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
